/**
 * Created by jv on 13/01/2017.
 */
import Cookies from "js-cookie"; // This gives errors in the browser, don't know why :(
//const Cookies = require("js-cookie");
const utils = require("Sources/utils/utils");

var storageController = {};

(function(StorageController)
{
  StorageController.keys = {
    LOGGED_IN_USER: "logged_in_user",
    SUBSCRIPTION_KEY: "subscription_key",
    ORDER_KEY: "order_key",
    DIGITAL_BOOK_KEY: "digital_book_key",
    USER_KEY: "user_key",
    CUSTOMER_KEY: "customer_key",
    GROUP_PURCHASE_KEY: "group_purchase_key",
    STORE_USER_LOCALE: "store_user_locale",
    STORE_USER_TYPE: "store_user_type",
    TOKEN_SESSION_LIMIT: "token_session_limit",
    STORE_PURCHASE_ORDER_REQUIRED: "store_purchase_order_required",
    ADMIN_ORDERS_FILTERS: "admin_orders_filters",
    ADMIN_SUBSCRIPTIONS_FILTERS: "admin_subscriptions_filters",
    COOKIEPOLIYCY_ANALYTICS_CONSENT: "cookiepolicy_analytics_consent"
  };

  StorageController.clearAll = function()
  {
    StorageController.clearSession();
    StorageController.clearLocal();
  };

  StorageController.clearSession = function()
  {
    sessionStorage.clear();
  };

  StorageController.clearLocal = function()
  {
    localStorage.clear();
  };

  StorageController.removeFromSession = function(key)
  {
    StorageController.saveToSession(key);
  };

  StorageController.saveToSession = function(key, obj)
  {
    if(storageKeyIsValid(key))
    {
      // if obj is null then remove
      if(utils.isUndefined(obj))
      {
        sessionStorage.removeItem(key);
      }
      else
      {
        if(utils.isObject(obj))
        {
          obj = utils.stringifyJSON(obj);
        }

        sessionStorage.setItem(key, obj);
      }
    }
    else
    {
      console.error("Invalid storage key [%s]", key);
    }
  };

  StorageController.getFromSession = function(key)
  {
    if(storageKeyIsValid(key))
    {
      var tmpValue = sessionStorage.getItem(key);

      if(tmpValue)
      {
        return utils.parseJSON(tmpValue, true);
      }

      return tmpValue;
    }
    else
    {
      console.error("Invalid storage key [%s]", key);
    }

    return null;
  };

  StorageController.removeFromLocal = function(key)
  {
    StorageController.saveToLocal(key);
  };

  StorageController.saveToLocal = function(key, obj)
  {
    if(storageKeyIsValid(key))
    {
      if(utils.isUndefined(obj))
      {
        localStorage.removeItem(key);
      }
      else
      {
        if(utils.isObject(obj))
        {
          obj = utils.stringifyJSON(obj);
        }

        localStorage.setItem(key, obj);
      }
    }
    else
    {
      console.error("Invalid storage key [%s]", key);
    }
  };

  StorageController.getFromLocal = function(key, json)
  {
    if(storageKeyIsValid(key))
    {
      var tmpValue = localStorage.getItem(key);

      if(tmpValue)
      {
        return utils.parseJSON(tmpValue, true);
      }

      return tmpValue;
    }
    else
    {
      console.error("Invalid storage key [%s]", key);
    }

    return null;
  };

  StorageController.saveCookie = function(name, value, daysUntilExpire)
  {
    var options = {};
    if(utils.isNumber(daysUntilExpire))
    {
      options.expires = daysUntilExpire;
    }

    Cookies.set(name, value, { expires: daysUntilExpire })
  };

  StorageController.getCookie = function(name)
  {
    return Cookies.get(name);
  };

  StorageController.removeCookie = function(name)
  {
    Cookies.remove(name);
  };

  function storageKeyIsValid(key)
  {
    for(var objKey in StorageController.keys)
    {
      if(StorageController.keys.hasOwnProperty(objKey) && StorageController.keys[objKey] === key)
      {
        return true;
      }
    }

    return false;
  }

}(storageController));

module.exports = storageController;



// WEBPACK FOOTER //
// ./app/js/services/storage-controller.js